var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{staticClass:"body"},[_c('span',[_c('span'),_c('span'),_c('span'),_c('span')]),_c('div',{staticClass:"base"},[_c('span'),_c('div',{staticClass:"face"})])]),_c('div',{staticClass:"longfazers"},[_c('span'),_c('span'),_c('span'),_c('span')])])
}]

export { render, staticRenderFns }